module.exports = __webpack_public_path__ + "static/media/bear_put_spread.5e2bf31b.png";